import { forwardRef, InputHTMLAttributes } from 'react';
import { Search } from 'lucide-react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, icon, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute inset-y-0 start-0 ps-3 flex items-center pointer-events-none text-slate-400">
              {icon}
            </div>
          )}
          <input
            ref={ref}
            className={`
              w-full rounded-xl border border-slate-200 dark:border-slate-600 
              bg-white dark:bg-slate-800 
              text-slate-900 dark:text-slate-100
              placeholder:text-slate-400
              focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20
              transition-colors
              ${icon ? 'ps-10' : 'ps-4'} pe-4 py-2.5
              ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20' : ''}
              ${className}
            `}
            {...props}
          />
        </div>
        {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';

// Search Input
const SearchInput = forwardRef<HTMLInputElement, Omit<InputProps, 'icon'>>(
  (props, ref) => {
    return <Input ref={ref} icon={<Search size={18} />} {...props} />;
  }
);

SearchInput.displayName = 'SearchInput';

export { Input, SearchInput };
